<template>
    <div class="hero is-small">
        <div class="hero-body">
            <div class="container">
                <h1 class="title">
                  We would like to say thank you 🎉
                </h1>
                <div class="subtitle" style="margin-top: 0.3rem;">
<!--                    We are looking forward to welcoming you back, please stay safe: <br>-->
<!--                      <li style="margin-top: 0.5rem;">Due to COVID restrictions, only 3 people are allowed to wait in the shop at one time</li>-->
<!--                      <li>Please remember to bring and wear a mask whilst inside</li>-->

                  To our customers and staff for your continued support during the pandemic.<br>
                  We are now fully open. <br>
                  Walk-ins are welcome at any opening time.
<!--                  <li style="margin-top: 0.5rem;">Walk-ins are welcome at any time</li>-->
<!--                  <li>Please continue to stay safe</li>-->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Notice"
    }
</script>

<style scoped>

    .y-so-serious-white-bg{
        background-image: url("../assets/y-so-serious-white.png");
        background-repeat: repeat;
    }

</style>